// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"IntroductionCards_TheComp__ZSXx6"};